export default __webpack_public_path__ + "static/lists-3f75612daa98deceda0bd82ef9bc7c07.png";